export default "__VITE_PUBLIC_ASSET__6f37753d__"